import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-skillspage',
  templateUrl: './skillspage.component.html',
  styleUrls: ['./skillspage.component.scss']
})
export class SkillspageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
